export function isHTMLDiv(el: any): HTMLDivElement {
    if(el instanceof HTMLDivElement ) {
        return el as HTMLDivElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLDivElement`)
    }
}
export function isHTMLForm(el: any): HTMLFormElement {
    if(el instanceof HTMLFormElement ) {
        return el as HTMLFormElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLFormElement`)
    }
}
export function isHTMLButton(el: any): HTMLButtonElement {
    if(el instanceof HTMLButtonElement ) {
        return el as HTMLButtonElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLButtonElement`)
    }
}
export function isHTMLanchor(el: any): HTMLAnchorElement {
    if(el instanceof HTMLAnchorElement ) {
        return el as HTMLAnchorElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLAnchorElement`)
    }
}
export function isHTMLDialog(el: any): HTMLDialogElement {
    if(el instanceof HTMLDialogElement ) {
        return el as HTMLDialogElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLDialogElement`)
    }
}
export function isHTMLIFrame(el: any): HTMLIFrameElement {
    if(el instanceof HTMLIFrameElement ) {
        return el as HTMLIFrameElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLIFrameElement`)
    }
}
export function isHTMLImage(el: any): HTMLImageElement {
    if(el instanceof HTMLImageElement ) {
        return el as HTMLImageElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLImageElement`)
    }
}
export function isFormValueElement(el: any): HTMLInputElement|HTMLSelectElement {
    if(el instanceof HTMLInputElement ) {
        return el as HTMLInputElement
    } else if (el instanceof HTMLSelectElement) {
        return el as HTMLSelectElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLDivElement`)
    }
}
export function isHTMLLIElement(el: any): HTMLLIElement {
    if(el instanceof HTMLLIElement ) {
        return el as HTMLLIElement
    } else {
        throw new Error(`argument ${el} is not of type HTMLLIElement`)
    }
}
